<template>
  <div class="w-full flex flex-col items-center">
    <menu-item
      v-for="(item, index) in resultList"
      :item="item"
      :key="index"
      @click="item.click ? item.click() : $emit('menu', item)"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { EVENTS as HW_EVENTS } from '@/events/hardware';
import $api from '@/modules/request';

import avatarShader from '@/assets/common/avatar-shader.svg';
import language from '@/assets/common/language.svg';
import feedback from '@/assets/common/feedback.svg';
import getHelp from '@/assets/common/get-help.svg';
import storeSettings from '@/assets/common/store-settings.svg';
import account from '@/assets/common/account-icon.svg';
import avatarShaderSanne from '@/assets/sanne/icons/avatar-shader.svg';
import languageSanne from '@/assets/sanne/icons/language.svg';
import feedbackSanne from '@/assets/sanne/icons/feedback.svg';
import getHelpSanne from '@/assets/sanne/icons/get-help.svg';
import storeSettingsSanne from '@/assets/sanne/icons/store-settings.svg';
import accountSanne from '@/assets/sanne/icons/account-icon.svg';
import brandMode from '@/mixins/brand-mode';
import MenuItem from './MenuItem.vue';

export default {
  components: {
    MenuItem,
  },
  mixins: [brandMode],
  props: {
    sortMenu: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapState('app', ['appReady', 'version']),
    ...mapGetters('mtmUser', ['companyName']),
    ...mapGetters('user', ['username']),
    ...mapState('hardware', ['appVersion']),
    ...mapState('mtmUser', { mtmUserMe: 'me' }),
    ...mapState('user', { userMe: 'me' }),
    list() {
      return [
        {
          img: this.brandAsset(avatarShader, avatarShaderSanne),
          name: this.$t('homePage.avatar_shader_3d'),
          target: '',
          pageName: 'avatar-shader',
        },
        {
          img: this.brandAsset(language, languageSanne),
          name: this.$t('homePage.language'),
          target: '',
          pageName: 'language',
        },
        {
          img: this.brandAsset(feedback, feedbackSanne),
          name: this.$t('homePage.feedback'),
          target: '',
          pageName: 'feedback',
        },
        {
          img: this.brandAsset(getHelp, getHelpSanne),
          name: this.$t('homePage.get_help'),
          target: '',
          pageName: 'get-help',
          click: () => {
            const scannerUuid = localStorage ? localStorage.getItem('tg3d-last-scanner') || '' : '';
            const scanTid = localStorage ? localStorage.getItem('tg3d-last-tid') || '' : '';
            const lastError = localStorage ? localStorage.getItem('tg3d-last-error') || '' : '';
            const apiHost = $api.user.defaults.baseURL;

            const feedbackID = crypto.randomUUID();
            console.log(`[ERROR] [USER_REPORT] ${feedbackID}`); // auto send feedback

            const isChinese = this.$i18n.locale === 'zh-tw';
            let baseUrl = isChinese
              ? 'https://share.hsforms.com/1DZroOlv5Syalt85Ulw6gGQdl1xc'
              : 'https://share.hsforms.com/1zzI0NFb5RB6DKSJRKrAaigdl1xc';
            // Sanne has its own help form, one for every language
            if (this.isSanne) baseUrl = 'https://share.hsforms.com/1NlsW0BT3TcuAYpji5O6QKgdl1xc';
            const searchParams = new URLSearchParams();
            searchParams.append('feedback_id', feedbackID);
            searchParams.append('user_name', this.username || '');
            searchParams.append('lastname', this.userMe.nick_name || '');
            searchParams.append('email', this.userMe.email || '');
            searchParams.append('phone', this.userMe.mobile_phone || '');
            searchParams.append('aws_region', apiHost);
            searchParams.append('mtm_account', JSON.stringify(this.mtmUserMe));
            searchParams.append('company', this.companyName);
            searchParams.append('scanner_uuid', scannerUuid);
            searchParams.append('scan_tid', scanTid);
            searchParams.append('web_version', this.version);
            searchParams.append('app_version', this.appVersion);
            searchParams.append('last_error', lastError.substring(0, 100));
            const url = `${baseUrl}?${searchParams.toString()}`;

            // wait feedback api
            this.$loadingPage.open();
            setTimeout(() => {
              this.$loadingPage.close();
              if (!this.appReady) {
                window.open(url);
                return;
              }
              this.$events.emit(HW_EVENTS.OPEN_LINK_IN_BROWSER, url);
            }, 2000);
          },
        },
        {
          img: this.brandAsset(storeSettings, storeSettingsSanne),
          name: this.$t('homePage.store_settings'),
          target: this.companyName,
          pageName: 'mtm-login',
        },
        {
          img: this.brandAsset(account, accountSanne),
          name: this.$t('homePage.account_settings'),
          target: '',
          pageName: 'user-setting',
        },
      ];
    },
    resultList() {
      const resultList = [];
      this.sortMenu.forEach(data => {
        const index = this.list.findIndex(item => item.pageName === data);
        resultList.push(this.list[index]);
      });

      return resultList;
    },
  },
};
</script>
